import HandlerRegistry  from './HandlerRegistry'
import { Event, IEventPayload } from '../events/BlockEvent'

export default class Dispatcher {
    private registry: HandlerRegistry

    constructor(registry: HandlerRegistry) {
        this.registry = registry
    }

    dispatch = (event: Event, payload: IEventPayload): void => {
        let handlers = this.registry.getHandlers(event)
        for (let handler of handlers){
            try {
                handler({payload})
            }
            catch (ex) {
                console.error(ex)
            }
        }
    }
}